require('./bootstrap');
import Vuex from 'vuex';

window.Vue = require('vue');
window.Vuex = Vuex;
window._ = require('lodash');
window.moment = require('moment');

Vue.use(Vuex);

// import PortalVue from 'portal-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Toasted from 'vue-toasted';
import datepicker from 'js-datepicker'
window.datepicker = datepicker;
// import VueQuill from 'vue-quill'


// If you don't need the styles, do not connect
import './bootstrap-slider/bootstrap-slider.min.js';

// window.Vue.use(PortalVue)
// Vue.use(VueQuill)
window.Vue.use(VueSweetalert2);
window.Vue.use(Toasted, {
     iconPack: 'fontawesome',
     theme: "outline",
     position: "top-right",
     duration : 5000,
});

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('activity-content', require('./components/ActivityContent.vue').default);
Vue.component('activity-preview', require('./components/ActivityPreview.vue').default);
Vue.component('activity-external', require('./components/External/ActivityExternal.vue').default);
Vue.component('activity-orders-external', require('./components/External/ActivityOrdersExternal.vue').default);

import storeFile from './store.js';

const app = new Vue({
    el: '#app',
    store: new Vuex.Store(storeFile),
});

$('.triggerActivityNameModal').click(function(event){
  event.preventDefault()
  $('#activityNameModal').modal('show')
})

$('.triggerStaffInviteModal').click(function(event){
  event.preventDefault()
  $('#staffInviteModal').modal('show')
})

$('.triggerPaymentMethodModal').click(function(event){
  event.preventDefault()
  $('#addPaymentMethodModal').modal('show')
})

$('.passwordModalTrigger').click(function(event){
  event.preventDefault()
  $('#changePasswordModal').modal('show')
})

$("#roundedCornersSlider").slider();
$("#roundedCornersSlider").on("slide", function(slideEvt) {
    $("#roundedCornersSliderValue").text(slideEvt.value);
});

// ----------------------------------------
// Create Activity Form
// ----------------------------------------
$('#createActivitySubmitButton').on('click', function() {
    $(this).attr('disabled', true);
    $(this).parents('form').submit();
});
$('#createActivityName').on('change', function() {
    $('#createActivitySubmitButton').attr('disabled', false);
});
$('#editActivitySubmitButton').on('click', function() {
    $(this).attr('disabled', true);
    $(this).parents('form').submit();
});

// ----------------------------------------
// Add attribute checked - Checkbox
// ----------------------------------------
$('.form-check label').on('click', function() {
  $(this).parent().siblings().removeClass('is-checked');
  $(this).parent().addClass('is-checked');
  var input = $(this).parent().find('input');
  input.attr('checked', 'checked')
});

// ----------------------------------------
// Add attribute checked - Theme Design
// ----------------------------------------
$('.form-check-theme').on('click', function() {
  $(this).siblings().removeClass('is-checked');
  $(this).addClass('is-checked');
  var otherInput = $(this).siblings().find('input');
  otherInput.removeAttr('checked');
  var input = $(this).find('input');
  input.attr('checked', 'checked');
  var otherLabel = $(this).siblings().find('label');
  otherLabel.text('Default');
  var label = $(this).find('label');
  label.text('Selezionato');
});

$('.logo_shape').on('click', function(){
  $('.activity-logo-dynamic').removeClass('square')
  $('.activity-logo-dynamic').removeClass('round')
  $('.activity-logo-dynamic').addClass($(this).val())

  $('iframe').contents().find('.activity-logo-dynamic').removeClass('square')
  $('iframe').contents().find('.activity-logo-dynamic').removeClass('round')
  $('iframe').contents().find('.activity-logo-dynamic').addClass($(this).val())
})

$('#logo-in-design').on('change', function(event){
  console.log('2')
  readURL(event.target)
})

function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('#logo-holder').show();
            $('#logo-shape-options').show();
            $('#logo-holder').attr('src', e.target.result);
            $('#logo-holder-init').hide()
        };

        reader.readAsDataURL(input.files[0]);
    }
}

$('#activity-link-copy-button').on('click', function(e){
  e.preventDefault()
  copyActivityLink()
});
$('.activity-link-copy-button').on('click', function(e){
  e.preventDefault()
  copyActivityLink()
})

function copyActivityLink() {
  /* Get the text field */
  var copyText = document.getElementById("activity-link-copy-target");

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /*For mobile devices*/

  document.execCommand("copy");
}


$('.remove-staff').click(function(){
  window.axios.post($(this).data('url')).then(() => {
    window.location.reload
  })
})

$('.reinvite-staff').click(function(e){
    e.preventDefault()
    console.log($(this).data('url'))
  window.axios.post($(this).data('url')).then(() => {
    window.location.reload()
  })
})

$('.cancel-invite-staff').click(function(e){
    e.preventDefault()
  window.axios.post($(this).data('url')).then(() => {
    window.location.reload()
  })
})

$('#languageSwitcherHandler').click(function(e) {
    e.preventDefault();
    $($(this).attr('data-rel')).toggleClass('d-none');
});
